import React from "react";

export default function OverweightModal({ open, weight, onConfirm, onCancel }) {
  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <h2>⚠ Overweight Shipment Warning</h2>

        <div style={styles.content}>
          <p>Your shipment weight is <span className="red">{Number(weight).toLocaleString()}</span> KGS</p>
<br/>
          <p>According to USA Shipment is highly concerned about the weight of the container.</p>
<br/>
          <p><strong>Overweight charge maybe applied</strong></p>
          <p>Port to Port: Maximum GW as per Container [Excluded COSCO/YML/ZIM]</p>

          <p>By Rail [ON-DOCK]: max 21,000 KGS / 20', 26,000 KGS / 40'&HQ<br/>
             By Rail [OFF-DOCK]: max 17,000 KGS / 20', 19,000 KGS / 40'&HQ</p>

          <p>By Truck: max 17,000 KGS / 20', 19,000 KGS / 40'&HQ</p>
<br/>
          <p>*** On-Dock / Off-Dock can be verified by USA COST SHEET or Carrier's confirmation<br/>
             *** Weight limitation by Rail for each carrier can be verified by USA COST SHEET or Carrier's confirmation<br/>
             *** Trucking for Door Delivery can check the weight with agent, Tri-Axle Chassis or Transload Option could be applied for overweight container.
          </p>
<br/>
          <p className="bold">Please ensure you have confirmed with the Pricing Team or Carrier about the overweight acceptance and surcharges.</p>
<br/>
          <p className="bold">Do you want to proceed?</p>
        </div>

        <div style={styles.buttonRow}>
          <button style={styles.okBtn} onClick={onConfirm}>OK</button>
          <button style={styles.cancelBtn} onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#fff",
    padding: "20px",
    borderRadius: "10px",
    width: "600px",
    maxHeight: "80vh",
    overflowY: "auto",
  },
  content: { marginBottom: "20px" },
  buttonRow: { display: "flex", justifyContent: "flex-end", gap: "10px" },
  okBtn: {
    background: "#1976d2",
    color: "#fff",
    padding: "8px 16px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
  },
  cancelBtn: {
    background: "#bdbdbd",
    padding: "8px 16px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
  },
};
